import React from 'react';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components/macro';

interface MarkerProps {
    iconName: IconName;
    color: string;
    size: string;
    iconColor: string;
    iconSize: string;
}
export const IconButtonVariables = [
    {
        variableName: 'iconName' as const,
        type: 'string' as const
    },
    {
        variableName: 'color' as const,
        type: 'string' as const
    },
    {
        variableName: 'size' as const,
        type: 'string' as const
    },
    {
        variableName: 'iconColor' as const,
        type: 'string' as const
    },
    {
        variableName: 'iconSize' as const,
        type: 'string' as const
    }
];

export const IconButtonMarker = (props: MarkerProps) => {
    const size = props.size ? props.size + 'px' : '40px';
    const iconColor = props.iconColor ?? 'white';
    const iconSize = props.iconSize ? props.iconSize : '18px';

    return (
        <S_IconButtonMarker $size={size} $color={props.color}>
            {props.iconName && (
                <S_Icon
                    icon={['far', props.iconName]}
                    $iconColor={iconColor}
                    $iconSize={iconSize}
                />
            )}
        </S_IconButtonMarker>
    );
};

const S_IconButtonMarker = styled.div<{ $size: string; $color: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${(props) => props.$size};
    height: ${(props) => props.$size};
    box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.15);
    background-color: ${(props) => props.$color};
    border-radius: 50%;
`;

const S_Icon = styled(FontAwesomeIcon)<{ $iconColor: string; $iconSize: string }>`
    color: ${(props) => props.$iconColor};
    font-size: ${(props) => props.$iconSize};
`;
